/**
 * Report variable type values
 */
export enum ReportVariableTypeEnum {
	STRING = 'string',
	NUMBER = 'number',
	BOOLEAN = 'boolean',
	DATE = 'date',
}
